export const AvailableMaterialTypes = [
  {
    localizationKeyOne: 'cases.materials.tissue',
    localizationKeyMany: 'cases.materials.tissues',
    value: 'tissues'
  },
  {
    localizationKeyOne: 'cases.materials.block',
    localizationKeyMany: 'cases.materials.blocks',
    value: 'blocks'
  },
  {
    localizationKeyOne: 'cases.materials.slide',
    localizationKeyMany: 'cases.materials.slides',
    value: 'slides'
  },
  {
    localizationKeyOne: 'cases.materials.document',
    localizationKeyMany: 'cases.materials.documents',
    value: 'documents'
  },
  {
    localizationKeyOne: 'cases.materials.file',
    localizationKeyMany: 'cases.materials.files',
    value: 'files'
  }
]
